import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';
import { StaticDocumentCategory } from '../utils/adaptStaticDocumentCategories';

const STALE_TIME = 1000 * 60 * 60; // 60 minutes

// Shared source of the static document categories used by both the bundle documents
// filters and the "upload static document" screen.
export const useStaticDocumentCategories = () => {
    const { i18n: { language } } = useTranslation();

    const { data, isLoading, error } = useGetCustomService({
        service: 'customDocumentsService',
        api: 'getAllStaticDocumentCategories',
        enabled: true,
        payload: { language },
        refetchOnWindowFocus: false,
        staleTime: STALE_TIME,
    });

    const categories = useMemo<StaticDocumentCategory[]>(
        () => data?.data?.categories || [],
        [data?.data?.categories],
    );

    return { categories, isLoading, error };
};

export default useStaticDocumentCategories;
